import { initForm, addSubmitListener } from "./form/form";
import input from "./input/input";
import inputOtp from "./inputOtp/inputOtp";
export function initCommon() {
    initForm();
    input();
    inputOtp();
}
export { initForm, addSubmitListener, input, inputOtp };
